import { InjectionToken } from "@angular/core";

export const BASE_ROUTE_NAVIGATORS = new InjectionToken<{
    nombre: string;
    url: string;
    icon_name: string;
    state: boolean;
    roles: string[];
}[]>('baseRouteNavigators');


export const provideBaseRouteNavigators = <T>(value: {
    nombre: string;
    url: string;
    icon_name: string;
    state: boolean;
    roles: T[];
}[]) => ({
    provide: BASE_ROUTE_NAVIGATORS,
    useValue: value
});